<template>
  <Header_m></Header_m>
  <meta content="user-scalable=no">
  <div @wheel.prevent="slide" id="index_m">
    <Index_index_m></Index_index_m>
    <Index_concept_m></Index_concept_m>
    <Index_team_m></Index_team_m>
    <Index_enterprise_m></Index_enterprise_m>
    <Index_news_m></Index_news_m>
    <Index_contact_m></Index_contact_m>
    <Index_affix_m></Index_affix_m>
    <router-view/>
  </div>
</template>

<script>
import Header_m from "@/components/CN_mobile/Header_m";
import Index_index_m from "@/components/CN_mobile/index/Index_index_m";
import Index_concept_m from "@/components/CN_mobile/index/Index_concept_m";
import Index_team_m from "@/components/CN_mobile/index/Index_team_m";
import Index_enterprise_m from "@/components/CN_mobile/index/Index_enterprise_m";
import Index_news_m from "@/components/CN_mobile/index/Index_news_m";
import Index_contact_m from "@/components/CN_mobile/index/Index_contact_m";
import {reactive, onMounted} from 'vue'
import Index_affix_m from "@/components/CN_mobile/index/Index_affix_m";

export default {
  name: 'Index_m',
  components: {
    Header_m,
    Index_contact_m,
    Index_enterprise_m,
    Index_team_m,
    Index_concept_m,
    Index_index_m,
    Index_news_m,
    Index_affix_m,
  },

  setup() {
    let time = reactive({
      prev: Date.now(),
      now: Date.now(),
      delay: 1000,
    })
    const slide = () => {
      time.now = Date.now()
      if (time.now - time.prev > time.delay) {
        if (window.event.deltaY > 0) {
          document.documentElement.scrollBy({
            top: window.innerHeight,
            behavior: "smooth",
          })
        } else {
          document.documentElement.scrollBy({
            top: -window.innerHeight,
            behavior: "smooth",
          })
        }
        time.prev = Date.now()
      }
    }

    const start = () => {
      let target = document.getElementById('index_m')
      let move = false
      let start_location = 0
      let listen_start = (e) => {
        start_location = e.touches[0].pageY
      }
      let listen_move = (e) => {
        move = true
        e.preventDefault()

      }
      let listen_end = (e) => {
        if (move === true) {
          move = false
          console.log(start_location - e.changedTouches[0].pageY) // <0 down >0 up
          if (start_location - e.changedTouches[0].pageY > 0) {
            document.documentElement.scrollBy({
              top: document.body.clientHeight,
              behavior: "smooth",
            })
          } else {
            document.documentElement.scrollBy({
              top: -document.body.clientHeight,
              behavior: "smooth",
            })
          }
        }
      }
      target.addEventListener('touchstart', listen_start, false)
      target.addEventListener('touchmove', listen_move, false)
      target.addEventListener('touchend', listen_end, false)

    }
    onMounted(() => {
      //document.addEventListener('DOMContentLoaded', start)
    })
    return {slide}
  }
}
</script>
<style>
::-webkit-scrollbar {
  display: none
}
</style>

